/**
 * @typedef {Object} ExperimentVariants
 * @property {string} A - Variant A
 * @property {string} B - Variant B
 */

/**
 * @typedef {Object} ExperimentConfig
 * @property {ExperimentVariants} variants - The variants for the experiment
 */

/**
 * VWO feature keys and variant token mapping (cookie / store values vs A/B slot).
 * Typed rather than inferred, so callers can look an experiment up by a runtime key.
 * @type {{ activeExperiments: Object.<string, ExperimentConfig> }}
 */
const experimentsConfig = {
  activeExperiments: {
    eventDetailAaFeatureFlag: {
      variants: {
        A: 'C',
        B: 'V2',
      },
    },
    cv09: {
      variants: {
        A: 'C',
        B: 'V2',
      },
    },
    cv10: {
      variants: {
        A: 'C',
        B: 'V2',
      },
    },
    cv11: {
      variants: {
        A: 'C',
        B: 'V2',
      },
    },
    // A = control (existing search UI), B = V1 (new search UI)
    cv13: {
      variants: {
        A: 'C',
        B: 'V1',
      },
    },
  },
}

export default experimentsConfig
